import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs/internal/Subscription';
import { MessService } from 'src/app/_services/mess-service.service';
import { OperationsService } from 'src/app/_services/operations.service';

@Component({
  selector: 'app-operations-add',
  templateUrl: './operations-add.component.html',
})
export class OperationsAddComponent implements OnInit, OnDestroy {
  addOperationForm: FormGroup;
  suboperations: FormArray;
  invalidFields: string[] = [];

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private operationsService: OperationsService,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.addOperationForm = this.fb.group({
      label: ['', Validators.required],
      name: ['', Validators.required],
      coefficient: [0, Validators.required],
      year: new Date().getFullYear(),
      cost: [''],
      suboperations: this.fb.array([]),
    });
    this.suboperations = this.addOperationForm.get(
      'suboperations'
    ) as FormArray;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Add operation === //
  onAddOperation() {
    let operation = this.addOperationForm.getRawValue();
    this.subscriptions.push(
      this.operationsService.addOperation(operation).subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno kreiranje',
            detail: 'Kreirali ste novu operaciju.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.addOperationForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * Helpers === //
  getControls() {
    return (<FormArray>this.addOperationForm.get('suboperations')).controls;
  }

  createSuboperation(): FormGroup {
    return this.fb.group({
      label: ['', Validators.required],
      name: ['', Validators.required],
      cost: [''],
    });
  }

  addSuboperation(): void {
    this.suboperations.push(this.createSuboperation());
  }

  removeSuboperation(suboperationId: number) {
    this.suboperations.removeAt(suboperationId);
  }
}
